import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import { AprovacaoService } from "../../services/AprovacaoService";
import { ExercicioService } from "../../services/ExercicioService";
import { UnidadeExecutoraService } from "../../services/UnidadeExecutoraService";
import { UnidadeOrcamentariaService } from "../../services/UnidadeOrcamentariaService";
import { ProgramaService } from "../../services/ProgramaService";
import { GrupoService } from "../../services/GrupoService";
import { ElementoService } from "../../services/ElementoService";
import { ElementoItemService } from "../../services/ElementoItemService";
import { FonteService } from "../../services/FonteService";
import moment from "moment";

export default {
    name: "GerenciarAprovacoes",
    components: {
        Breadcrumb,
        StandardPagination,
        ActionButtons
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Aprovações',
                disabled: false
            },
            {
                text: 'Gerenciamento de Aprovações Orçamentárias',
                disabled: true
            }
        ],
        headers: [
            { text: 'Código Aprovação', align: 'center', value: 'codigo_aprovacao', width: '120px' },
            { text: 'Exercício', align: 'center', value: 'exercicio', width: '100px' },
            { text: 'Unid. Executora', align: 'center', value: 'unidade_executora', width: '150px' },
            { text: 'Unid. Orçamentária', align: 'center', value: 'unidade_orcamentaria', width: '150px' },
            { text: 'Programa', align: 'center', value: 'programa', width: '150px' },
            { text: 'Grupo', align: 'center', value: 'grupo', width: '150px' },
            { text: 'Elemento', align: 'center', value: 'elemento', width: '150px' },
            { text: 'Elemento Item', align: 'center', value: 'elemento_item', width: '150px' },     
            { text: 'Fonte', align: 'center', value: 'fonte', width: '150px' },         
            { text: 'Data Aprovação', align: 'center', value: 'data_aprovacao', width: '120px' },
            { text: 'Valor Aprovação', align: 'center', value: 'valor_aprovacao', width: '140px' },
        ],
        filters: {
            codigoFilter: null,
            exercicioFilter: null,
            unidadeExecutoraFilter: null,
            unidadeOrcamentariaFilter: null,
            acaoFilter: null,
            programaFilter: null,
            grupoFilter: null,
            elementoFilter: null,
            elementoItemFilter: null,
            ipgFilter: null,
            fonteFilter: null,
            aprovacaoAtivoFilter: false,
            aprovacaoInativoFilter: false,
            dataInicio: null,
            dataFim: null,
        },
        items: [],
        itemSelected: [],
        modalEdit: false,
        modalCreate: false,
        exerciciosOptions: [],
        acaoOptions: [],
        ipuOptions: [],
        ipgOptions: [],
        grupoOptions: [],
        programaOptions: [],
        elementoOptions: [],
        elementoItemOptions: [],
        fonteOptions: [],
        unidadeExecutoraOptions: [],
        unidadeOrcamentariaOptions: [],
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        itemsPerPageOptions: [10, 20, 50],
        showFilters: true
    }),
    computed: {
        computedHeaders() {
            return this.headers;
        },
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        }
    },
    created() {
        this.listarAprovacoesPaginado();
        this.listarExerciciosSelect();
        this.listarGruposSelect();
        this.listarProgramasSelect();
        this.listarElementosItensSelect();
        this.listarElementosSelect();
        this.listarFontesSelect();
        this.listarUnidadeExecutoraSelect();
        this.listarUnidadeOrcamentariaSelect()
    },
    watch: {
        page: async function(newValue) {
            this.page = newValue;
            await this.listarAprovacoesPaginado();
        },
        'filters.codigoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarAprovacoesPaginado();
            }
        },
        'filters.exercicioFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarAprovacoesPaginado();
            }
        },
        'filters.unidadeExecutoraFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarAprovacoesPaginado();
            }
        },
        'filters.unidadeOrcamentariaFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarAprovacoesPaginado();
            }
        },
        'filters.programaFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarAprovacoesPaginado();
            }
        },
        'filters.grupoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarAprovacoesPaginado();
            }
        },
        'filters.elementoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarAprovacoesPaginado();
            }
        },
        'filters.elementoItemFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarAprovacoesPaginado();
            }
        },
        'filters.fonteFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarAprovacoesPaginado();
            }
        },
        'filters.dataInicio': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarAprovacoesPaginado();
            }
        },
        'filters.dataFim': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarAprovacoesPaginado();
            }
        }
    },
    methods: {
        async listarAprovacoesPaginado() {
            try {
                const filter = this.prepareFormFilter();

                const response = await AprovacaoService.index(filter);

                if (typeof response !== 'string') {
                    this.items = response.data.data;
                    this.totalItems = response.data.total;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os aprovações:', error);
            }
        },
        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                    this.exerciciosOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os aprovações:', error);
            }
        },
        async listarGruposSelect() {
            try {
                const response = await GrupoService.select();
                if (response) {
                    this.grupoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_grupo} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.grupoOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os aprovações:', error);
            }
        },
        async listarProgramasSelect() {
            try {
                const response = await ProgramaService.select();
                if (response) {
                    this.programaOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_programa} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.programaOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os aprovações:', error);
            }
        },
        async listarUnidadeExecutoraSelect() {
            try {
                const response = await UnidadeExecutoraService.select();
                if (response) {
                    this.unidadeExecutoraOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_unidade} - ${el.nome}`,
                            value: el.id,
                        };
                    });
                    this.unidadeExecutoraOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os aprovações:', error);
            }
        },
        async listarUnidadeOrcamentariaSelect() {
            try {
                const response = await UnidadeOrcamentariaService.select();
                if (response) {
                    this.unidadeOrcamentariaOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_unidade} - ${el.nome}`,
                            value: el.id,
                        };
                    });
                    this.unidadeOrcamentariaOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os aprovações:', error);
            }
        },
        async listarElementosItensSelect() {
            try {
                const response = await ElementoItemService.select();
                if (response) {
                    this.elementoItemOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_elemento_item} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.elementoItemOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os aprovações:', error);
            }
        },
        async listarElementosSelect() {
            try {
                const response = await ElementoService.select();
                if (response) {
                    this.elementoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_elemento} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.elementoOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os aprovações:', error);
            }
        },
        async listarFontesSelect() {
            try {
                const response = await FonteService.select();
                if (response) {
                    this.fonteOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_fonte} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.fonteOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os aprovações:', error);
            }
        },
        async destroyAprovacoes() {
            try {
                const ids = this.itemSelected.map(aprovacao => aprovacao.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("aprovacoes[]", id);
                });

                const response = await AprovacaoService.destroy(formData);

                if (!response) {
                    console.error('Não foi possível excluir os aprovações.');
                }

                this.listarAprovacoesPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao excluir os aprovações:', error);
            }
        },
        openModal(value) {
            if (value == 'create') {
                this.modalCreate = true;
            }
            if (value == 'edit') {
                this.modalEdit = true;
            }
        },
        closeActionsDialog() {
            this.modalCreate = false;
        },

        prepareFormFilter() {
            const filter = new FormData();

            filter.append("page", this.page);
            filter.append("items_per_page", this.itemsPerPage);

            this.filters.exercicioFilter
            ? filter.append(
                "exercicio",
                this.filters.exercicioFilter
            )
            : null;

            this.filters.codigoFilter
            ? filter.append(
                "codigo_aprovacao",
                this.filters.codigoFilter
            )
            : null;

            this.filters.unidadeExecutoraFilter
            ? filter.append(
                "unidade_executora_id",
                this.filters.unidadeExecutoraFilter
            )
            : null;

            this.filters.unidadeOrcamentariaFilter
                ? filter.append(
                    "unidade_orcamentaria_id",
                    this.filters.unidadeOrcamentariaFilter
                )
                : null;

            this.filters.programaFilter
                ? filter.append(
                    "programa_id",
                    this.filters.programaFilter
                )
                : null;    

            this.filters.grupoFilter
                ? filter.append(
                    "grupo_id",
                    this.filters.grupoFilter
                )
                : null;  

            this.filters.elementoFilter
                ? filter.append(
                    "elemento_id",
                    this.filters.elementoFilter
                )
                : null;      

            this.filters.elementoItemFilter
                ? filter.append(
                    "elemento_item_id",
                    this.filters.elementoItemFilter
                )
                : null;     
                
            this.filters.fonteFilter
                ? filter.append(
                    "fonte_id",
                    this.filters.fonteFilter
                )
                : null;    

            this.filters.dataInicio
                ? filter.append(
                    "data_ini",
                    moment(this.filters.dataInicio).format("YYYY-MM-DD")
                  )
                : null;
            this.filters.dataFim
                ? filter.append(
                    "data_fim",
                    moment(this.filters.dataFim).format("YYYY-MM-DD")
                  )
                : null;    

            return filter;
        },
        clearFilters() {
            Object.keys(this.filters).forEach(key => {
                this.filters[key] = null;
            });
            this.page = 1;
            this.listarAprovacoesPaginado();
        },
        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },
        getRowClass() {
            return 'table-row';
        },
        truncateText(text, maxLength) {
            if (!text) return '-';
            if (text.length <= maxLength) return text;
            return text.substring(0, maxLength) + '...';
        },
        formatCurrency(value) {
            if (value == null || value === undefined) return 'R$ 0,00';
            const numValue = typeof value === 'string' ? parseFloat(value) : value;
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(numValue);
        },
        formatDate(date) {
            if (!date) return '-';
            return moment(date).format('DD/MM/YYYY');
        },
        handlePageChange(newPage) {
            this.page = newPage;
            this.listarAprovacoesPaginado();
        },
        handleItemsPerPageChange(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarAprovacoesPaginado();
        },
        exportarAprovacoes() {
            this.$globalAlert('Funcionalidade de exportação será implementada em breve!');
        },
        handleVisualizarAprovacao() {
            if (this.itemSelected.length === 1) {
                this.$router.push(`/aprovacoes/visualizar/${this.itemSelected[0].id}`);
            }
        },
        handleImportar() {
            this.$router.push('/importar-aprovacoes-orcamentarias');
        },
        formatCodigo(codigo1, codigo2) {
            if (codigo1 == 0 && codigo2 == 0) {
              return '0';
            } else if (codigo1 == 0) {
              return `${codigo2}`;
            } else if (codigo2 == 0) {
              return `${codigo1}`;
            } else if (codigo1 < 10 && codigo2 >= 10) {
              return `${codigo2}${codigo1}`;
            } else if (codigo1 >= 10 && codigo2 < 10) {
                return `${codigo1}0${codigo2}`;
            } else {
              return `${codigo1}${codigo2}`;
            }
        },
        formatDescricao(descricao1, descricao2) {
            if (!descricao1 && !descricao2) return '-';
            if (descricao1 == descricao2) {
                return descricao1;
            } else if (!descricao1) {
                return descricao2;
            } else if (!descricao2) {
                return descricao1;
            } else {
                return `${descricao1} - ${descricao2}`;
            }
        }
        
    }
};
